export default __webpack_public_path__ + "static/reviewer-image-5-cd294136eea733e44c9d79f0e4be3cf9.png";